import { Typography } from "@mui/material";
import CustomStatusChip from "@/components/custom/custom-status-chip";
import { formatDateTime } from "@/utils/format-date";
import { ACTIVE_STATUS_STYLES, toActiveStatus } from "../../data";

export const getGatewayColumns = ({ onEdit, onToggle }) => [
  {
    accessorKey: "name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Gateway</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.name ?? "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "description",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Description</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.82rem" color="text.secondary">
        {row.original.description ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "active",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => (
      <CustomStatusChip
        status={toActiveStatus(row.original.active)}
        styles={ACTIVE_STATUS_STYLES}
      />
    ),
  },
  {
    accessorKey: "updated_at",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Last Updated</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>
        {formatDateTime(row.original.updated_at ?? row.original.created_at)}
      </div>
    ),
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Action</div>,
    cell: ({ row }) => (
      <div style={{ display: "flex", gap: 12 }}>
        <Typography
          onClick={(e) => { e.stopPropagation(); onEdit?.(row.original); }}
          sx={{ fontSize: "0.82rem", fontWeight: 600, color: "primary.main", cursor: "pointer" }}
        >
          Edit
        </Typography>
        <Typography
          onClick={(e) => { e.stopPropagation(); onToggle?.(row.original); }}
          sx={{
            fontSize: "0.82rem",
            fontWeight: 600,
            color: row.original.active ? "error.main" : "success.main",
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          {row.original.active ? "Disable" : "Activate"}
        </Typography>
      </div>
    ),
  },
];